import queryString from 'query-string';
import {
	// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
	createResource,
	type RouterContext,
	type RouterDataContext,
	type RouteResource,
} from '@atlassian/react-resource-router';
import type { Page, Workflow } from './ApiQueryParams.types.tsx';
import { getListWorkFlows } from './getListWorkFlows.tsx';

const WORKFLOWS_TABLE_TYPE = 'WORKFLOWS_TABLE';
const WORKFLOWS_TABLE_KEY = 'WORKFLOWS_TABLE_KEY';

const workFlowsResource: RouteResource<Page<Workflow>> = createResource<Page<Workflow>>({
	type: WORKFLOWS_TABLE_TYPE,
	getKey: ({ query }: RouterContext) => `${WORKFLOWS_TABLE_KEY}-${queryString.stringify(query)}`,
	maxAge: 0,
	getData: async ({ query }: RouterDataContext) => getListWorkFlows(queryString.stringify(query)),
});

export default workFlowsResource;
